import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Descend = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Descend' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,8 L8,2 L14,8 M11,21 L22,21 M11,17 L19,17 M11,13 L16,13 M8,2 L8,22' transform='matrix(1 0 0 -1 0 24)' />
  </StyledIcon>
);
